import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Block,
    BlockDes,
    PreviewCard,
    BlockHead,
    BlockBetween,
    BlockHeadContent,
    BlockTitle,
    Icon,
    BackTo,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { Row, Col, FormGroup, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { Button } from "../../../components/Component";
import classNames from "classnames";
import { useQuery, useMutation } from "@tanstack/react-query";
import { loginAxios } from '../../../config/axios.config';
import DatePicker from "react-datepicker";
import moment from "moment";
// import { Icon } from "../../components/";
import { RSelect } from "../../../components/Component";
import { toast, ToastContainer } from "react-toastify";
const DesignerDetails = () => {
    const { errors, register, handleSubmit, control, getValues, setValue, watch } = useForm();
    const [details, setDetails] = useState({});
    const [bannerImage, setbannerImage] = useState("");
    const [GstAttach, setGstAttach] = useState("");
    const [MsmeAttach, setMsmeAttach] = useState("");
    const [PanAttach, setPanAttach] = useState('');
    const [chequeAttach, setChequeAttach] = useState('');
    const [contractAttach, setContractAttach] = useState('');
    const [gstRegistered, setGstRegistered] = useState(0);
    const [msmeRegistered, setMsmeRegistered] = useState(false);
    const [gstRegDate, setGstRegDate] = useState('');
    const [MsmeRegDate, setMsmeRegDate] = useState('');
    const [signatureDate, setSignatureDate] = useState('');
    const [tagValues, setTagValues] = useState([]);
    const [tagArr, setTagArr] = useState([]);
    const [merchandisername1Values, setMerchandisername1Values] = useState({});
    const [merchandisername2Values, setMerchandisername2Values] = useState({});
    const userLoginDetails = JSON.parse(localStorage.getItem("userInitDetails"));

    const onFormSubmit = (e) => {

        var payload = {
            "email": e.primaryEmail,
            // "legal_name": details?.designerName,            
            "company_name": e.companyname,
            "brand_name": e.brandname,
            "classification_tag": tagValues.map(item => item.label).join(", "),
            "address": e.addressnlin1,
            "address_line1": e.addressnlin2,
            "landmark": e.landmark,
            "city": e.city,
            "state": e.state?.value,
            // "state": e.state,
            "country": e.country,
            "pincode": parseInt(e.pincode),
            "phone": parseInt(e.contactDetails),
            "contact_name_primary": e.primaryContactName,
            "email_contact_primary": e.primaryContactEmail,
            "email_cc": e.secondaryEmail,
            "phone_contact_primary": parseInt(e.primaryContactPhone),
            "contact_primary_job_title": e.primaryContactJobTitle,
            "contact_name_secondary": e.secondaryContactName,
            "email_contact_secondary": e.secondaryContactEmail,
            "phone_contact_secondary": parseInt(e.secondaryContactPhone),
            "contact_job_title_secondary": e.secondaryContactJobTitle,


            "reg_email_to": e.regprimaryEmail,

            "reg_address": e.regaddressnlin1,
            "reg_address_line1": e.regaddressnlin2,
            "reg_address_line2": e.reglandmark,
            "reg_city": e.regcity,
            "reg_state": e.regstate?.value,
            // "reg_state": e.regstate,
            "reg_country": e.regcountry,
            "reg_pincode": parseInt(e.regpincode),
            "reg_phone": parseInt(e.regcontactDetails),
            "reg_contact_name_primary": e.regprimaryContactName,
            "reg_email_contact_primary": e.regprimaryContactEmail,
            "reg_email_cc": e.regsecondaryEmail,
            "reg_phone_contact_primary": parseInt(e.regprimaryContactPhone),
            "reg_contact_primary_job_title": e.regprimaryContactJobTitle,
            "reg_contact_name_secondary": e.regsecondaryContactName,
            "reg_email_contact_secondary": e.regsecondaryContactEmail,
            "reg_phone_contact_secondary": parseInt(e.regsecondaryContactPhone),
            "reg_contact_job_title_secondary": e.regsecondaryContactJobTitle,



            "gst_registered": gstRegistered == true ? 1 : 0,
            "gst_no": e.gstNo,
            "gst_registration_date": e.gstRegDate,
            "pan_number": e.panNumber,
            "bank_account_number": e.bankAccountNumber,
            "bank_name": e.bankName,
            "branch_name": e.branchName,
            "ifsc_code": e.ifscCode,
            "declaration_flag": 1,

            "signature_name": e.signatureName,
            "signature_place": e.signaturePlace,
            "signature_date": e.signatureDate,
            "designation": e.designation,
            "merchandiser_name1": merchandisername1Values.value,
            "merchandiser_name2": merchandisername2Values.value,

            "msme_registered": msmeRegistered == true ? 1 : 0,
            "msme_registration_no": e.msmeRegistrationNo,
            "msme_registration_date": e.msmeRegistrationDate,

            "gst_attachment": GstAttach,
            "baner_image": bannerImage,
            "pan_attachment": PanAttach,
            "cancelled_cheque_attachment": chequeAttach,
            "contract_document": contractAttach,
            "msme_certificate": MsmeAttach,

            // "designer_description": e.designerDesc,
            // "declaration": e.declaration,
        }

        // console.log(payload);

        saveDesignerDetailsCall.mutate(payload);

    };
    const formClass = classNames({
        "form-validate": true,
        "is-alter": true,
    });



    ///////////////// /////////////////////////////////////save FILE  ///////////////////////////  /////////////////////////// ///////////////////////////



    const saveFile = async (params) => {
        try {
            const { data } = await loginAxios.post(`designers/upload-document`, params.formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };


    const saveFileCall = useMutation(saveFile)

    const handleFileSave = (e, file_type) => {

        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append("doc_type", file_type);
        var payload = {
            formData
        }
        saveFileCall.mutate(payload, {
            onSettled(data, error) {
                if (data) {
                    if (file_type == 'gst_attachment') {
                        setGstAttach(data.data.file_path)
                    }
                    if (file_type == 'pan_attachment') {
                        setPanAttach(data.data.file_path)
                    }
                    if (file_type == 'baner_image') {
                        setbannerImage(data.data.file_path)
                    }
                    if (file_type == 'cancelled_cheque_attachment') {
                        setChequeAttach(data.data.file_path)
                    }
                    if (file_type == 'contract_document') {
                        setContractAttach(data.data.file_path)
                    }                    
                    if (file_type == 'msme_certificate') {
                        setMsmeAttach(data.data.file_path)
                    }

                } else if (error) {
                    toast.error(error.response.data.data[0].message, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        progress: false,
                    });



                }
            }
        });

    }


    ///////////////// /////////////////////////////////////save API CALLLL  ///////////////////////////  /////////////////////////// ///////////////////////////


    const saveDesignerDetails = async (params) => {
        try {
            const { data } = await loginAxios.post(`designers/user-details`, params, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };


    const saveDesignerDetailsCall = useMutation(saveDesignerDetails, {
        onSettled(data, error) {
            if (data) {
                toast.success(data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    progress: false,
                });

            } else if (error) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    progress: false,
                });
            }

            setIsEdit(!isEdit);
            fetchProFileDetails();
        }
    })

    ///////////////// /////////////////////////////////////save API CALLLL  ///////////////////////////  /////////////////////////// ///////////////////////////


    const getProfileDetails = async () => {
        try {
            const { data } = await loginAxios.get(`designers/user-details`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const { isFetching, isLoading, error, isSuccess, isError, data, refetch: fetchProFileDetails } = useQuery(['getProfileDetails'], getProfileDetails, {
        // refetchOnMount: false,
        // refetchOnWindowFocus: false,
        enabled: false,
        onSettled(data, error) {
            if (data) {
                setDetails(data?.data);
                setGstRegistered(data?.data?.gstRegistered)
                if (data?.data?.msmeRegistered == 1) {
                    setMsmeRegistered(true)
                } else {
                    setMsmeRegistered(false)
                }

                setbannerImage(data?.data?.banerImage);
                setGstAttach(data?.data?.gstAttachment);
                setPanAttach(data?.data?.panAttachment);
                setMsmeAttach(data?.data?.msmeCertificate);
                setChequeAttach(data?.data?.cancelledChequeAttachment);
                setContractAttach(data?.data?.contract_document)                

                if (data?.data?.gstRegistrationDate != null) {
                    setGstRegDate(moment(data?.data?.gstRegistrationDate).format('YYYY-MM-DD'));
                } else {
                    setGstRegDate(data?.data?.gstRegistrationDate);
                }

                if (data?.data?.msmeRegistrationDate != null) {
                    setMsmeRegDate(moment(data?.data?.msmeRegistrationDate).format('YYYY-MM-DD'));
                } else {
                    setMsmeRegDate(data?.data?.msmeRegistrationDate);
                }

                if (data?.data?.signatureDate != null) {
                    setSignatureDate(moment(data?.data?.signatureDate).format('YYYY-MM-DD'));
                } else {
                    setSignatureDate(data?.data?.signatureDate);
                }

                var string = data?.data?.classificationTag;
                const mappedArr = string.split(',').map(item => item != '' && ({ value: item, label: item }))

                setTagValues(mappedArr);

                setMerchandisername1Values({ value: data?.data?.merchandiserName, label: data?.data?.merchandiserName });
                setMerchandisername2Values({ value: data?.data?.orderMerchandiserName, label: data?.data?.orderMerchandiserName })

            }
        }
    });



    const getClassificationTags = async () => {
        try {
            const { data } = await loginAxios.get(`designers/classification-tag`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const classificationTagsCall = useQuery(['getClassificationTags'], getClassificationTags, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        onSettled(data, error) {
            if (data) {
                // const arrayObj = data?.data.map(item => {
                //     return {State
                //       value: item.id,
                //       label: item.name
                //     };
                //   });

                const arrayObj = data?.data.map(item => {
                    return {
                        value: item.name,
                        label: item.name
                    };
                });

                setTagArr(arrayObj)
            }
        }
    });




    const [merchandiserArr, setmerchandiserArr] = useState([]);

    const merchandiserList = async () => {
        try {
            const { data } = await loginAxios.get(`designers/merchandiser-list`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const merchandiserListCall = useQuery(['merchandiserList'], merchandiserList, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        onSettled(data, error) {
            if (data) {
                const arrayObj = data?.data.map(item => {
                    return {
                        value: item.email,
                        label: item.fullName
                    };
                });

                setmerchandiserArr(arrayObj)
            }
        }
    });

    // const [pincodeOptions, setPincodeOptions] = useState([]);

    // const pincodeArr = async () => {
    //     try {
    //         const { data } = await loginAxios.get(`designers/pincode`, {
    //             headers: {
    //                 'x-auth-token': localStorage.getItem('accessToken')
    //             }
    //         });
    //         return data;
    //     } catch (error) {
    //         return Promise.reject(error);
    //     }
    // };

    // const pincodeArrCall = useQuery(['pincodeArr'], pincodeArr, {
    //     refetchOnMount: false,
    //     refetchOnWindowFocus: false,
    //     onSettled(data, error) {
    //         if (data) {
    //             const arrayObj = data?.data?.pincode_details.map(item => {

    //                 item.value = item.pincode;
    //                 item.label = item.pincode;
    //                 return item
    //             });

    //             setPincodeOptions(arrayObj);
    //         }
    //     }
    // });

    const [modalLg, setModalLg] = useState(false);
    const toggleLg = () => setModalLg(!modalLg);
    const [isEdit, setIsEdit] = useState(false);













    ///////////////// /////////////////////////////////////GET STATE ARRAY API CALL  ///////////////////////////  /////////////////////////// ///////////////////////////

    const [statesArr, setStatesArr] = useState([]);

    const getStates = async (params) => {
        try {
            const { data } = await loginAxios.get(`designers/drp/state_dropdown`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };


    const getStatesCall = useMutation(getStates, {
        onSettled(data, error) {
            if (data) {
                var temp = data?.data?.list.map((item, index) => {
                    item.label = item.stateName;
                    item.value = item.stateName;
                    return item;
                });
                setStatesArr(temp);
            } else if (error) {
                console.log(error);
            }
        }
    });

    useEffect(() => {

        Promise.allSettled([getStatesCall.mutateAsync()])
        .then(results => {
            console.log('call here again');
            fetchProFileDetails()
        })

    },[]);

///////////////// /////////////////////////////////////GET STATE ARRAY API CALL ENDS HERE...  ///////////////////////////  /////////////////////////// ///////////////////////////

    // var statesArr = [{ value: "Andhra Pradesh", label: "Andhra Pradesh" },
    // { value: "Andaman and Nicobar Islands", label: "Andaman and Nicobar Islands" },
    // { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
    // { value: "Assam", label: "Assam" },
    // { value: "Bihar", label: "Bihar" },
    // { value: "Chandigarh", label: "Chandigarh" },
    // { value: "Chhattisgarh", label: "Chhattisgarh" },
    // { value: "Dadar and Nagar Haveli", label: "Dadar and Nagar Haveli" },
    // { value: "Daman and Diu", label: "Daman and Diu" },
    // { value: "Delhi", label: "Delhi" },
    // { value: "Lakshadweep", label: "Lakshadweep" },
    // { value: "Puducherry", label: "Puducherry" },
    // { value: "Goa", label: "Goa" },
    // { value: "Gujarat", label: "Gujarat" },
    // { value: "Haryana", label: "Haryana" },
    // { value: "Himachal Pradesh", label: "Himachal Pradesh" },
    // { value: "Jammu and Kashmir", label: "Jammu and Kashmir" },
    // { value: "Jharkhand", label: "Jharkhand" },
    // { value: "Karnataka", label: "Karnataka" },
    // { value: "Kerala", label: "Kerala" },
    // { value: "Madhya Pradesh", label: "Madhya Pradesh" },
    // { value: "Maharashtra", label: "Maharashtra" },
    // { value: "Manipur", label: "Manipur" },
    // { value: "Meghalaya", label: "Meghalaya" },
    // { value: "Mizoram", label: "Mizoram" },
    // { value: "Nagaland", label: "Nagaland" },
    // { value: "Odisha", label: "Odisha" },
    // { value: "Punjab", label: "Punjab" },
    // { value: "Rajasthan", label: "Rajasthan" },
    // { value: "Sikkim", label: "Sikkim" },
    // { value: "Tamil Nadu", label: "Tamil Nadu" },
    // { value: "Telangana", label: "Telangana" },
    // { value: "Tripura", label: "Tripura" },
    // { value: "Uttar Pradesh", label: "Uttar Pradesh" },
    // { value: "Uttarakhand", label: "Uttarakhand" },
    // { value: "West Bengal", label: "West Bengal" }
    // ];


    const [copyAddress, setCopyAddress] = useState(false);

    const handleCopyAddress = (e) => {

        setCopyAddress(e.target.checked);

        console.log(watch('state'));

        if (e.target.checked == true) {

            setValue("regaddressnlin1", watch('addressnlin1'));
            setValue("regaddressnlin2", watch('addressnlin2'));
            setValue("reglandmark", watch('landmark'));
            setValue("regpincode", watch('pincode'));
            setValue("regcity", watch('city'));
            setValue("regstate", watch('state'));
            // setValue("regstate", watch('state').value);
            setValue("regcontactDetails", watch('contactDetails'));
            setValue("regsecondaryEmail", watch('secondaryEmail'));
            setValue("regprimaryContactName", watch('primaryContactName'));
            setValue("regprimaryContactEmail", watch('primaryContactEmail'));
            setValue("regprimaryContactPhone", watch('primaryContactPhone'));
            setValue("regprimaryContactJobTitle", watch('primaryContactJobTitle'));
            setValue("regsecondaryContactName", watch('secondaryContactName'));
            setValue("regsecondaryContactEmail", watch('secondaryContactEmail'));
            setValue("regsecondaryContactPhone", watch('secondaryContactPhone'));
            setValue("regsecondaryContactJobTitle", watch('secondaryContactJobTitle'));

        } else {

            setValue("regaddressnlin1", '');
            setValue("regaddressnlin2", '');
            setValue("reglandmark", '');
            setValue("regpincode", '');
            setValue("regcity", '');
            setValue("regstate", '');
            setValue("regcontactDetails", '');
            setValue("regsecondaryEmail", '');
            setValue("regprimaryContactName", '');
            setValue("regprimaryContactEmail", '');
            setValue("regprimaryContactPhone", '');
            setValue("regprimaryContactJobTitle", '');
            setValue("regsecondaryContactName", '');
            setValue("regsecondaryContactEmail", '');
            setValue("regsecondaryContactPhone", '');
            setValue("regsecondaryContactJobTitle", '');
        }

    }


    const onDownload2 = () => {
        fetch("/DELCARATION CUM UNDERTAKING-NEW.docx").then((response) => {
          response.blob().then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "DELCARATION CUM UNDERTAKING.docx";
            a.click();
          });
        });
      };

      

    return (<>
        <Content page="component">

            <Block size="lg">
                {/* <BlockHead>
                    <BlockHeadContent>
                        <BlockTitle tag="h5">Designer Profile Details</BlockTitle>                        
                    </BlockHeadContent>
                </BlockHead> */}


                {/* <button onClick={testArr}>TEST</button> */}

                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h5">
                                Designer Profile Details-

                                {(userLoginDetails.profile_approval_status != "NOT_INITIATED" || userLoginDetails.profile_approval_status != "REJECTED" || userLoginDetails.profile_approval_status != "PENDING") ? ` Approval Status: ${userLoginDetails.profile_approval_status}` : null}
                                
                                <br />
                                <span style={{color: 'red', textDecoration: 'underline', fontStyle: 'italic', fontSize: '21px'}}>{userLoginDetails?.profile_approval_ticker}</span>
                            </BlockTitle>

                            

                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <div className="toggle-expand-content">
                                    <ul className="nk-block-tools g-3">
                                        <li className="nk-block-tools-opt">

                                            {!isEdit && <Button color="primary"
                                                onClick={() => setIsEdit(!isEdit)}
                                            >
                                                <Icon name="edit" />
                                                <span>Edit</span>
                                            </Button>
                                            }

                                            {isEdit && <Button outline color="light"
                                                onClick={() => setIsEdit(!isEdit)}
                                            >
                                                <Icon name="edit" />
                                                <span>Cancel</span>
                                            </Button>
                                            }
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <PreviewCard>
                    {/* <FormValidationComponent id="form-2" alter /> */}

                    <h5>Basic Profile Details</h5>

                    <Form className={formClass} onSubmit={handleSubmit(onFormSubmit)}>
                        <Row className="g-gs">
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="brand-name">
                                        Brand Name*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            // ref={register({ required: true })}
                                            ref={register({
                                                pattern: {
                                                    value: /^((?!\.com\b)(?!\.in\b)(?!\.org\b)(?!\.co\b).)*$/,                                                                                                        
                                                    message: "Please enter valid name",
                                                },
                                                required: 'This field is required',
                                            })}

                                            type="text"
                                            id="brand-name"
                                            name="brandname"
                                            className="form-control"
                                            defaultValue={details?.brandName}
                                            // disabled={!isEdit}
                                            readOnly={!isEdit}
                                        />
                                        {/* {errors.brandname && <span className="invalid">This field is required</span>} */}
                                        {errors.brandname && <span className="invalid">{errors.brandname.message}</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="company-name">
                                        Company Name*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="company-name"
                                            name="companyname"
                                            className="form-control"
                                            defaultValue={details?.companyName}
                                            // disabled={!isEdit}
                                            readOnly={!isEdit}
                                        />
                                        {errors.companyname && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="merchandiser-name1">
                                        Aza merchandiser Name 1
                                    </Label>
                                    <Controller
                                        control={control}
                                        // defaultValue={default_value}
                                        name="merchandisername1"
                                        render={({ onChange, value, name, ref }) => (
                                            <RSelect
                                                inputRef={ref}
                                                classNamePrefix="addl-class"
                                                options={merchandiserArr}
                                                value={merchandisername1Values}
                                                onChange={val => {
                                                    setMerchandisername1Values(val);
                                                    onChange(val);
                                                }}
                                                isDisabled={!isEdit}
                                            />
                                        )}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="merchandiser-name2">
                                        Aza merchandiser Name 2
                                    </Label>
                                    <Controller
                                        control={control}
                                        // defaultValue={default_value}
                                        name="merchandisername2"
                                        render={({ onChange, value, name, ref }) => (
                                            <RSelect
                                                inputRef={ref}
                                                classNamePrefix="addl-class"
                                                options={merchandiserArr}
                                                value={merchandisername2Values}
                                                onChange={val => {
                                                    setMerchandisername2Values(val);
                                                    onChange(val);
                                                }}
                                                isDisabled={!isEdit}
                                            />
                                        )}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <label className="form-label">Designer Type</label>
                                    <Controller
                                        control={control}
                                        // defaultValue={default_value}
                                        name="classificationTag"
                                        render={({ onChange, value, name, ref }) => (
                                            <RSelect
                                                inputRef={ref}
                                                classNamePrefix="addl-class"
                                                options={tagArr}
                                                value={tagValues}
                                                onChange={val => {
                                                    setTagValues(val);
                                                    onChange(val);
                                                }}
                                                isDisabled={!isEdit}
                                                isMulti

                                            // value={classificationTagsCall?.data?.data.find(c => c.name === name)}
                                            // options={classificationTagsCall?.data?.data}
                                            />
                                        )}
                                    />

                                </FormGroup>
                            </Col>
                        </Row>

                        <h5 className="mt-3">Communication Address Details</h5>
                        <Row className="g-gs">

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="address-line1">
                                        Address line 1*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="address-line1"
                                            name="addressnlin1"
                                            className="form-control"
                                            // value={details?.address}
                                            defaultValue={details?.address}
                                            disabled={!isEdit}
                                        />
                                        {errors.addressnlin1 && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="address-line2">
                                        Address line 2*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="address-line2"
                                            name="addressnlin2"
                                            className="form-control"
                                            defaultValue={details?.addressLine1}
                                            disabled={!isEdit}
                                        />
                                        {errors.addressnlin2 && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="landmark">
                                        Landmark
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            // ref={register({ required: true })}
                                            ref={register()}
                                            type="text"
                                            id="landmark"
                                            name="landmark"
                                            className="form-control"
                                            defaultValue={details?.addressLine2}
                                            disabled={!isEdit}
                                        // value={details?.addressLine2}
                                        />
                                        {/* {errors.landmark && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="pincode">
                                        Pincode*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({
                                                pattern: {
                                                    value: /^[1-9][0-9]{5}$/,
                                                    message: "Please enter valid Pincode",
                                                },
                                                required: "Please enter valid Pincode",
                                            })}
                                            type="text"
                                            id="pincode"
                                            name="pincode"
                                            className="form-control"
                                            defaultValue={details?.pincode}
                                            disabled={!isEdit}
                                        />
                                        {errors.pincode && <span className="invalid">{errors.pincode.message}</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="city">
                                        City*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="city"
                                            name="city"
                                            className="form-control"
                                            defaultValue={details?.city}
                                            disabled={!isEdit}
                                        />
                                        {errors.city && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            {/* <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="state">
                                        State*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="state"
                                            name="state"
                                            className="form-control"
                                            defaultValue={details?.state}
                                            disabled={!isEdit}
                                        />
                                        {errors.state && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col> */}

                            {details?.state != null && <Col md="6">
                                <FormGroup>
                                    <label className="form-label">State*</label>
                                    <Controller
                                        control={control}
                                        name="state"
                                        rules={{ required: true }}
                                        // defaultValue={details?.state}
                                        defaultValue={statesArr.find(c => c.value === details?.state)}
                                        render={({ onChange, value, name, ref }) => (
                                            <RSelect
                                                inputRef={ref}
                                                isSearchable
                                                classNamePrefix="addl-class"
                                                options={statesArr}
                                                defaultValue={statesArr.find(c => c.value === details?.state)}
                                                value={statesArr.find(c => c.value === value)}
                                                onChange={val => {                                                    
                                                    onChange(val);
                                                }}
                                                isDisabled={!isEdit}
                                            />
                                        )}
                                    />
                                    {errors.state && <span className="invalid-r-select">This field is required</span>}
                                </FormGroup>
                            </Col>
                            }


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="country">
                                        Country
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="country"
                                            name="country"
                                            className="form-control"
                                            defaultValue={"India"}
                                            disabled={!isEdit}
                                            readOnly
                                        />
                                        {/* {errors.country && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="contactDetails">
                                        Contact details*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input

                                            ref={register({
                                                required: true,
                                                pattern: {
                                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                                    // value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                                    value: /((\+*)((0[ -]*)*|((91 )*))((\d{12})+|(\d{10})+))|\d{5}([- ]*)\d{6}/,
                                                    message: "Invalid phone number",
                                                },
                                            })}
                                            type="text"
                                            id="contactDetails"
                                            name="contactDetails"
                                            className="form-control"
                                            defaultValue={details?.phone}
                                            disabled={!isEdit}
                                        />

                                        {errors.contactDetails && <span className="invalid">This field is required</span>}
                                        {errors.contactDetails && errors.contactDetails.type === "pattern" && (
                                            <span className="invalid">{errors.contactDetails.message}</span>
                                        )}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="primaryEmail">
                                        Primary Email*
                                    </Label>
                                    <div className="form-control-wrap">

                                        <input
                                            // ref={register({ required: true })}
                                            ref={register({

                                                // pattern: {
                                                //     value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                //     message: "Please enter valid email-id",
                                                // },
                                                required: "Please enter valid email-id",
                                            })}
                                            type="text"
                                            id="primaryEmail"
                                            name="primaryEmail"
                                            className="form-control"
                                            defaultValue={details?.emailTo}
                                            disabled={!isEdit}
                                            readOnly
                                        />
                                        {errors.primaryEmail && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="secondaryEmail">
                                        Secondary Email
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register()}
                                            type="text"
                                            id="secondaryEmail"
                                            name="secondaryEmail"
                                            className="form-control"
                                            defaultValue={details?.emailCc}
                                            disabled={!isEdit}
                                        />
                                        {/* {errors.secondaryEmail && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>

                            {/* **************** primary contact details ************** */}

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="primaryContactName">
                                        Primary Contact - Name*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="primaryContactName"
                                            name="primaryContactName"
                                            className="form-control"
                                            defaultValue={details?.contactNamePrimary}
                                            disabled={!isEdit}
                                        />
                                        {errors.primaryContactName && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="primaryContactEmail">
                                        Primary Contact - Email*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({
                                                pattern: {
                                                    value: /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/,
                                                    message: "Please enter valid email-id",
                                                },
                                                required: "Please enter valid email-id",
                                            })}
                                            type="text"
                                            id="primaryContactEmail"
                                            name="primaryContactEmail"
                                            className="form-control"
                                            defaultValue={details?.emailContactPrimary}
                                            disabled={!isEdit}
                                        />
                                        {errors.primaryContactEmail && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="primaryContactPhone">
                                        Primary Contact - Phone*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({
                                                required: true,
                                                pattern: {
                                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                                    message: "Invalid phone number",
                                                },
                                            })}

                                            type="text"
                                            id="primaryContactPhone"
                                            name="primaryContactPhone"
                                            className="form-control"
                                            defaultValue={details?.phoneContactPrimary}
                                            disabled={!isEdit}
                                        />

                                        {errors.primaryContactPhone && errors.primaryContactPhone.type === "required" && <span className="invalid">This is required</span>}
                                        {errors.primaryContactPhone && errors.primaryContactPhone.type === "pattern" && (
                                            <span className="invalid">{errors.primaryContactPhone.message}</span>
                                        )}

                                        {/* {errors.primaryContactPhone && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>



                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="primaryContactJobTitle">
                                        Primary Contact - Designation*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="primaryContactJobTitle"
                                            name="primaryContactJobTitle"
                                            className="form-control"
                                            defaultValue={details?.contactPrimaryJobTitle}
                                            disabled={!isEdit}
                                        />
                                        {errors.primaryContactJobTitle && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            {       /* ************************************** primary contact details ENDS HERE>>>>>> ***************************************** */}




                            {/* **************** primary contact details ************** */}

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="secondaryContactName">
                                        Secondary Contact - Name
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            // ref={register({ required: true })}
                                            ref={register()}
                                            type="text"
                                            id="secondaryContactName"
                                            name="secondaryContactName"
                                            className="form-control"
                                            defaultValue={details?.contactNameSecondary}
                                            disabled={!isEdit}
                                        />
                                        {/* {errors.secondaryContactName && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="secondaryContactEmail">
                                        Secondary Contact - Email
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            // ref={register({ required: true })}
                                            ref={register()}
                                            type="text"
                                            id="secondaryContactEmail"
                                            name="secondaryContactEmail"
                                            className="form-control"
                                            defaultValue={details?.emailContactSecondary}
                                            disabled={!isEdit}
                                        />
                                        {/* {errors.secondaryContactEmail && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="secondaryContactPhone">
                                        Secondary Contact - Phone
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            // ref={register({ required: true })}
                                            ref={register()}
                                            type="number"
                                            id="secondaryContactPhone"
                                            name="secondaryContactPhone"
                                            className="form-control"
                                            defaultValue={details?.phoneContactSecondary}
                                            disabled={!isEdit}
                                        />
                                        {/* {errors.secondaryContactPhone && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>



                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="secondaryContactJobTitle">
                                        Secondary Contact - Designation
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            // ref={register({ required: true })}
                                            ref={register()}
                                            type="text"
                                            id="secondaryContactJobTitle"
                                            name="secondaryContactJobTitle"
                                            className="form-control"
                                            defaultValue={details?.contactJobTitleSecondary}
                                            disabled={!isEdit}
                                        />
                                        {/* {errors.secondaryContactJobTitle && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>

                            {       /* ************************************** primary contact details ENDS HERE>>>>>> ***************************************** */}

                        </Row>

                        <h5 className="mt-3">Registered Address Details</h5>
                        <Row className="g-gs">

                            <Col md="12">
                                <input
                                    checked={copyAddress}
                                    type="checkbox"
                                    // className="custom-control-input form-control"
                                    name="reg-address"
                                    id="addressCopy"
                                    onChange={(e) => handleCopyAddress(e)}
                                    disabled={!isEdit}
                                />
                                <label style={{ textTransform: 'underline', marginLeft: '10px' }} htmlFor="addressCopy">Same As Communication Address</label>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="reg-address-line1">
                                        Registered Address line 1*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="reg-address-line1"
                                            name="regaddressnlin1"
                                            className="form-control"
                                            defaultValue={details?.regAddress}
                                            disabled={!isEdit}
                                        />
                                        {errors.addressnlin1 && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="reg-address-line2">
                                        Registered Address line 2*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="reg-address-line2"
                                            name="regaddressnlin2"
                                            className="form-control"
                                            defaultValue={details?.regAddressLine1}
                                            disabled={!isEdit}
                                        />
                                        {errors.regaddressnlin2 && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="reglandmark">
                                        Registered Landmark
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register()}
                                            type="text"
                                            id="reglandmark"
                                            name="reglandmark"
                                            className="form-control"
                                            defaultValue={details?.regAddressLine2}
                                            disabled={!isEdit}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regpincode">
                                        Registered Pincode*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({
                                                pattern: {
                                                    value: /^[1-9][0-9]{5}$/,
                                                    message: "Please enter valid regPincode",
                                                },
                                                required: "Please enter valid regPincode",
                                            })}
                                            type="text"
                                            id="regpincode"
                                            name="regpincode"
                                            className="form-control"
                                            defaultValue={details?.regPincode}
                                            disabled={!isEdit}
                                        />
                                        {errors.regpincode && <span className="invalid">{errors.regpincode.message}</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regcity">
                                        Registered City*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="regcity"
                                            name="regcity"
                                            className="form-control"
                                            defaultValue={details?.regCity}
                                            disabled={!isEdit}
                                        />
                                        {errors.regcity && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            {/* <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regstate">
                                        Registered State*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="regstate"
                                            name="regstate"
                                            className="form-control"
                                            defaultValue={details?.regState}
                                            disabled={!isEdit}
                                        />
                                        {errors.regstate && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col> */}

                            {details?.regState != null &&
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Registered State*</label>
                                        <Controller
                                            control={control}
                                            name="regstate"
                                            // defaultValue={details?.regState}
                                            defaultValue={statesArr.find(c => c.value === details?.regState)}
                                            rules={{ required: true }}
                                            render={({ onChange, value, name, ref }) => (
                                                <RSelect
                                                    inputRef={ref}
                                                    isSearchable
                                                    classNamePrefix="addl-class"
                                                    options={statesArr}
                                                    defaultValue={statesArr.find(c => c.value === details?.regState)}
                                                    value={statesArr.find(c => c.value === value)}
                                                    onChange={val => {                                                        
                                                        onChange(val);
                                                    }}
                                                    isDisabled={!isEdit}
                                                />
                                            )}
                                        />
                                        {errors.regstate && <span className="invalid-r-select">This field is required</span>}
                                    </FormGroup>
                                </Col>
                            }

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regcountry">
                                        Registered Country
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="regcountry"
                                            name="regcountry"
                                            className="form-control"
                                            defaultValue="India"
                                            disabled={!isEdit}
                                            readOnly
                                        />
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regcontactDetails">
                                        Registered Contact details*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input

                                            ref={register({
                                                required: true,
                                                pattern: {
                                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                                    // value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                                    value: /((\+*)((0[ -]*)*|((91 )*))((\d{12})+|(\d{10})+))|\d{5}([- ]*)\d{6}/,
                                                    message: "Invalid phone number",
                                                },
                                            })}
                                            type="text"
                                            id="regcontactDetails"
                                            name="regcontactDetails"
                                            className="form-control"
                                            defaultValue={details?.regPhone}
                                            disabled={!isEdit}
                                        />

                                        {errors.regcontactDetails && <span className="invalid">This field is required</span>}
                                        {errors.regcontactDetails && errors.regcontactDetails.type === "pattern" && (
                                            <span className="invalid">{errors.regcontactDetails.message}</span>
                                        )}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regprimaryEmail">
                                        Registered Primary Email*
                                    </Label>
                                    <div className="form-control-wrap">

                                        <input
                                            ref={register({
                                                required: "Please enter valid email-id",
                                            })}
                                            type="text"
                                            id="regprimaryEmail"
                                            name="regprimaryEmail"
                                            className="form-control"
                                            // defaultValue={details?.regprimaryEmail}
                                            defaultValue={JSON.parse(localStorage.getItem("userInitDetails"))?.user_details?.email}
                                            disabled={!isEdit}
                                            readOnly
                                        />
                                        {errors.regprimaryEmail && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regsecondaryEmail">
                                        Registered Secondary Email
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register()}
                                            type="text"
                                            id="regsecondaryEmail"
                                            name="regsecondaryEmail"
                                            className="form-control"
                                            defaultValue={details?.regEmailCc}
                                            disabled={!isEdit}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>

                            {/* **************** primary contact details ************** */}

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regprimaryContactName">
                                        Registered Primary Contact - Name*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="regprimaryContactName"
                                            name="regprimaryContactName"
                                            className="form-control"
                                            defaultValue={details?.regContactNamePrimary}
                                            disabled={!isEdit}
                                        />
                                        {errors.regprimaryContactName && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regprimaryContactEmail">
                                        Registered Primary Contact - Email*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({
                                                pattern: {
                                                    value: /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/,
                                                    message: "Please enter valid email-id",
                                                },
                                                required: "Please enter valid email-id",
                                            })}
                                            type="text"
                                            id="regprimaryContactEmail"
                                            name="regprimaryContactEmail"
                                            className="form-control"
                                            defaultValue={details?.regEmailContactPrimary}
                                            disabled={!isEdit}
                                        />
                                        {errors.regprimaryContactEmail && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regprimaryContactPhone">
                                        Registered Primary Contact - Phone*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({
                                                required: true,
                                                pattern: {
                                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                                    message: "Invalid phone number",
                                                },
                                            })}

                                            type="text"
                                            id="regprimaryContactPhone"
                                            name="regprimaryContactPhone"
                                            className="form-control"
                                            defaultValue={details?.regPhoneContactPrimary}
                                            disabled={!isEdit}
                                        />

                                        {errors.regprimaryContactPhone && errors.regprimaryContactPhone.type === "required" && <span className="invalid">This is required</span>}
                                        {errors.regprimaryContactPhone && errors.regprimaryContactPhone.type === "pattern" && (
                                            <span className="invalid">{errors.regprimaryContactPhone.message}</span>
                                        )}

                                        {/* {errors.primaryContactPhone && <span className="invalid">This field is required</span>} */}
                                    </div>
                                </FormGroup>
                            </Col>



                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regprimaryContactJobTitle">
                                        Registered Primary Contact - Designation*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="regprimaryContactJobTitle"
                                            name="regprimaryContactJobTitle"
                                            className="form-control"
                                            defaultValue={details?.regContactPrimaryJobTitle}
                                            disabled={!isEdit}
                                        />
                                        {errors.regprimaryContactJobTitle && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regsecondaryContactName">
                                        Registered Secondary Contact - Name
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register()}
                                            type="text"
                                            id="regsecondaryContactName"
                                            name="regsecondaryContactName"
                                            className="form-control"
                                            defaultValue={details?.regContactNameSecondary}
                                            disabled={!isEdit}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regsecondaryContactEmail">
                                        Registered Secondary Contact - Email
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register()}
                                            type="text"
                                            id="regsecondaryContactEmail"
                                            name="regsecondaryContactEmail"
                                            className="form-control"
                                            defaultValue={details?.regEmailContactSecondary}
                                            disabled={!isEdit}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regsecondaryContactPhone">
                                        Registered Secondary Contact - Phone
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register()}
                                            type="number"
                                            id="regsecondaryContactPhone"
                                            name="regsecondaryContactPhone"
                                            className="form-control"
                                            defaultValue={details?.regPhoneContactSecondary}
                                            disabled={!isEdit}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>



                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="regsecondaryContactJobTitle">
                                        Registered Secondary Contact - Designation
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register()}
                                            type="text"
                                            id="regsecondaryContactJobTitle"
                                            name="regsecondaryContactJobTitle"
                                            className="form-control"
                                            defaultValue={details?.regContactJobTitleSecondary}
                                            disabled={!isEdit}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>

                            {       /* ************************************** primary contact details ENDS HERE>>>>>> ***************************************** */}

                        </Row>


                        <h5 className="mt-3">GST Details</h5>
                        <Row className="g-gs">
                            <Col md="12">


                                <Label className="form-label mr-2">GST Registered? </Label>

                                <div className="custom-control custom-radio mr-2">
                                    <input
                                        ref={register({
                                            required: true
                                        })}
                                        type="radio"
                                        className="form-control custom-control-input"
                                        id={"gstRegisteredYes"}
                                        name="gstRegistered"
                                        // value={details?.gstRegistered == 1 ? true : false}
                                        checked={gstRegistered == 1 ? true : false}
                                        disabled={!isEdit}
                                        onChange={(e) => {                                            
                                            if (e.target.checked) {
                                                setGstRegistered(true)
                                            }
                                        }}
                                        // defaultValue={true}
                                    />
                                    <Label className="custom-control-label" htmlFor={"gstRegisteredYes"}>
                                        Yes
                                    </Label>

                                </div>


                                <div className="custom-control custom-radio">
                                    <input
                                        ref={register({
                                            required: true
                                        })}
                                        type="radio"
                                        className="form-control custom-control-input"
                                        id={"gstRegisteredNo"}
                                        name="gstRegistered"
                                        // value={gstRegistered == 0 ? true : false}
                                        checked={gstRegistered == 0 ? true : false}
                                        disabled={!isEdit}
                                        onChange={(e) => {                                            
                                            if (e.target.checked) {
                                                setGstRegistered(false)
                                            }
                                        }}
                                    // defaultValue={details?.gstRegistered}
                                    />
                                    <Label className="custom-control-label" htmlFor={"gstRegisteredNo"}>
                                        No
                                    </Label>
                                </div>
                                <div>
                                    {errors.gstRegistered && <span className="custom-radio-msg">This field is required</span>}
                                </div>



                                {/* <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="form-control custom-control-input"
                                        id={"gst-registered"}
                                        name="gst-registered"
                                        checked={gstRegistered}
                                        onChange={(e) => setGstRegistered(e.target.checked)}
                                        disabled={!isEdit}
                                    />
                                    <Label className="custom-control-label" htmlFor={"gst-registered"}>
                                        GST Registered?
                                    </Label>
                                </div> */}
                            </Col>

                            {gstRegistered == 1 && <>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-label" htmlFor="gstNo">
                                            GST Number*
                                        </Label>
                                        <div className="form-control-wrap">
                                            <input
                                                // ref={register({ required: true })}

                                                ref={register({
                                                    pattern: {
                                                        value: /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/,
                                                        message: "Please enter valid GST Number",
                                                    },
                                                    required: "Please enter valid GST Number"
                                                })}

                                                type="text"
                                                id="gstNo"
                                                name="gstNo"
                                                className="form-control"
                                                defaultValue={details?.gstNo}
                                                disabled={!isEdit}
                                            />
                                            {errors.gstNo && <span className="invalid">This field is required</span>}
                                            {errors.gstNo && errors.gstNo.type === "pattern" && (
                                                <span className="invalid">{errors.gstNo.message}</span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>

                                <Col sm="6">
                                    <div className="form-group">
                                        <label className="form-label">GST Attachment*</label>
                                        <div className="form-control-wrap">
                                            <div className="custom-file">
                                                <input
                                                    type="file"
                                                    className="custom-file-input"
                                                    id="GSTFile"
                                                    name="GSTFile"
                                                    ref={register({
                                                        required: (details?.gstAttachment == null || details?.gstAttachment == '') ? true : false,
                                                    })}
                                                    onChange={(e) => handleFileSave(e, 'gst_attachment')}
                                                    disabled={!isEdit}
                                                />
                                                <label className="custom-file-label" htmlFor="GSTFile">
                                                    {GstAttach === "" ? "Choose files" : GstAttach}
                                                </label>
                                                {errors.GSTFile && <span className="invalid">This field is required</span>}
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col md="6">
                                    <FormGroup style={{ zIndex: '99' }}>
                                        <label className="form-label">GST Registration Date*</label>

                                        <Controller
                                            control={control}
                                            name="gstRegDate"
                                            render={(props) => (
                                                <DatePicker
                                                    className="input"
                                                    placeholderText="Select date"
                                                    onChange={(e) => {
                                                        props.onChange(e);
                                                        setGstRegDate(moment(e).format('YYYY-MM-DD'))
                                                    }}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={props.value}
                                                    maxDate={new Date()}
                                                    dateFormat="yyyy-MM-dd"
                                                    customInput={
                                                        <div className="form-control-wrap">
                                                            <input
                                                                ref={register({ required: true })}
                                                                type="text"
                                                                id="gstRegDate"
                                                                name="gstRegDate"
                                                                className="form-control"
                                                                defaultValue={gstRegDate}
                                                                value={gstRegDate}
                                                                disabled={!isEdit}
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                autoComplete="off"
                                                            />
                                                            {errors.gstRegDate && <span className="invalid">This field is required</span>}
                                                        </div>
                                                    }
                                                />
                                            )}
                                        />
                                    </FormGroup>
                                </Col>
                            </>}



                            {gstRegistered == 0 && <>                                
                                <Col sm="6">
                                    <div className="form-group">
                                        <label className="form-label">GST Attachment*</label>
                                        <div className="form-control-wrap">
                                            <div className="custom-file">
                                                <input
                                                    type="file"
                                                    className="custom-file-input"
                                                    id="GSTFile"
                                                    name="GSTFile"
                                                    ref={register({
                                                        required: (details?.gstAttachment == null || details?.gstAttachment == '') ? true : false,
                                                    })}
                                                    onChange={(e) => handleFileSave(e, 'gst_attachment')}
                                                    disabled={!isEdit}
                                                />
                                                <label className="custom-file-label" htmlFor="GSTFile">
                                                    {GstAttach === "" ? "Choose files" : GstAttach}
                                                </label>
                                                {errors.GSTFile && <span className="invalid">This field is required</span>}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm="6" style={{display: 'table'}}>                                    
                                    <a style={{display: 'table-cell',verticalAlign: 'bottom'}} href="https://product-dump.s3.amazonaws.com/DELCARATION+CUM+UNDERTAKING.docx" download><Icon name="download" /> Download declaration file</a>                                    
                                </Col>
                            </>}

                        </Row>


                        <h5 className="mt-3">MSME Details</h5>

                        <Row className="g-gs">
                            <Col md="12">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="form-control custom-control-input"
                                        id={"msme-registered"}
                                        name="msme-registered"
                                        checked={msmeRegistered}
                                        onChange={(e) => setMsmeRegistered(e.target.checked)}
                                        disabled={!isEdit}
                                    />
                                    <Label className="custom-control-label" htmlFor={"msme-registered"}>
                                        MSME Registered?
                                    </Label>
                                </div>
                            </Col>

                            {msmeRegistered && <>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-label" htmlFor="msmeRegistrationNo">
                                            MSME Number*
                                        </Label>
                                        <div className="form-control-wrap">
                                            <input
                                                // ref={register({ required: true })}
                                                ref={register({
                                                    pattern: {
                                                        // value: /^[a-zA-Z0-9]{12}/,
                                                        value: /^[0-9A-Za-z!@\.;:'"?-]{1,19}$/,
                                                        message: "Please enter valid MSME Number",
                                                    },
                                                    required: "Please enter valid MSME Number",
                                                })}



                                                type="text"
                                                id="msmeRegistrationNo"
                                                name="msmeRegistrationNo"
                                                className="form-control"
                                                defaultValue={details?.msmeRegistrationNo}
                                                disabled={!isEdit}
                                            />
                                            {errors.msmeRegistrationNo && <span className="invalid">This field is required</span>}
                                            {errors.msmeRegistrationNo && errors.msmeRegistrationNo.type === "pattern" && (
                                                <span className="invalid">{errors.msmeRegistrationNo.message}</span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>

                                <Col sm="6">
                                    <div className="form-group">
                                        <label className="form-label">MSME Attachment*</label>

                                        {/* <span class="tb-lead">
                                            <a href={details?.msmeCertificate} download target="_blank"> <Icon name="download" /> {details?.msmeCertificate}</a>
                                        </span> */}

                                        <div className="form-control-wrap">
                                            <div className="custom-file">
                                                <input
                                                    type="file"
                                                    className="custom-file-input"
                                                    id="MSMEFile"
                                                    name="MSMEFile"
                                                    ref={register({
                                                        required: (details?.msmeCertificate == null || details?.msmeCertificate == '') ? true : false,
                                                    })}
                                                    onChange={(e) => handleFileSave(e, 'msme_certificate')}
                                                    disabled={!isEdit}
                                                />
                                                <label className="custom-file-label" htmlFor="MSMEFile">
                                                    {MsmeAttach === "" ? "Choose files" : MsmeAttach}
                                                </label>
                                                {errors.MSMEFile && <span className="invalid">This field is required</span>}
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col md="6">
                                    <FormGroup style={{ zIndex: '99' }}>
                                        <label className="form-label">MSMSE Registration Date*</label>

                                        <Controller
                                            control={control}
                                            name="MsmeRegDate"
                                            render={(props) => (
                                                <DatePicker
                                                    className="input"
                                                    placeholderText="Select date"
                                                    onChange={(e) => {
                                                        props.onChange(e);
                                                        setMsmeRegDate(moment(e).format('YYYY-MM-DD'))
                                                    }}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={props.value}
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    customInput={
                                                        <div className="form-control-wrap">
                                                            <input
                                                                ref={register({ required: true })}
                                                                type="text"
                                                                id="MsmeRegDate"
                                                                name="MsmeRegDate"
                                                                className="form-control"
                                                                defaultValue={MsmeRegDate}
                                                                value={MsmeRegDate}
                                                                disabled={!isEdit}
                                                                onKeyDown={(e) => e.preventDefault()}
                                                                autoComplete="off"
                                                            />
                                                            {errors.MsmeRegDate && <span className="invalid">This field is required</span>}
                                                        </div>
                                                    }
                                                />
                                            )}
                                        />
                                    </FormGroup>
                                </Col>
                            </>}
                        </Row>


                        <Row className="g-gs">


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="panNumber">
                                        PAN Number*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            // ref={register({ required: true })}

                                            ref={register({
                                                pattern: {
                                                    value: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                                                    message: "Please enter valid PAN Number",
                                                },
                                                required: "Please enter valid PAN Number",
                                            })}


                                            type="text"
                                            id="panNumber"
                                            name="panNumber"
                                            className="form-control"
                                            defaultValue={details?.panNumber}
                                            disabled={!isEdit}
                                        />
                                        {errors.panNumber && <span className="invalid">This field is required</span>}
                                        {errors.panNumber && errors.panNumber.type === "pattern" && (
                                            <span className="invalid">{errors.panNumber.message}</span>
                                        )}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col sm="6">
                                <div className="form-group">
                                    <label className="form-label">PAN Attachment*</label>

                                    <div className="form-control-wrap">
                                        <div className="custom-file">
                                            <input
                                                type="file"
                                                className="custom-file-input"
                                                id="PANFile"
                                                name="PANFile"
                                                ref={register({
                                                    required: (details?.panAttachment == null || details?.panAttachment == '') ? true : false,
                                                })}
                                                onChange={(e) => handleFileSave(e, 'pan_attachment')}
                                                disabled={!isEdit}
                                            />
                                            <label className="custom-file-label" htmlFor="PANFile">
                                                {PanAttach === "" ? "Choose files" : PanAttach}
                                            </label>
                                            {errors.PANFile && <span className="invalid">This field is required</span>}
                                        </div>
                                    </div>
                                </div>
                            </Col>

                        </Row>

                        <h5 className="mt-3">Payment Details</h5>

                        <Row className="g-gs">

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="bankAccountNumber">
                                        Bank Account Number*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="bankAccountNumber"
                                            name="bankAccountNumber"
                                            className="form-control"
                                            defaultValue={details?.bankAccountNumber}
                                            disabled={!isEdit}
                                        />
                                        {errors.bankAccountNumber && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="bankName">
                                        Bank Name*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="bankName"
                                            name="bankName"
                                            className="form-control"
                                            defaultValue={details?.bankName}
                                            disabled={!isEdit}
                                        />
                                        {errors.bankName && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="branchName">
                                        Branch Name*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="branchName"
                                            name="branchName"
                                            className="form-control"
                                            defaultValue={details?.branchName}
                                            disabled={!isEdit}
                                        />
                                        {errors.branchName && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="ifscCode">
                                        IFSC Code*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="ifscCode"
                                            name="ifscCode"
                                            className="form-control"
                                            defaultValue={details?.ifscCode}
                                            disabled={!isEdit}
                                        />
                                        {errors.ifscCode && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col sm="6">
                                <div className="form-group">
                                    <label className="form-label">Cancelled Cheque Attachment*</label>

                                    <div className="form-control-wrap">
                                        <div className="custom-file">
                                            <input
                                                ref={register({
                                                    required: (details?.cancelledChequeAttachment == null || details?.cancelledChequeAttachment == '') ? true : false,
                                                })}
                                                type="file"
                                                className="custom-file-input"
                                                id="customFile"
                                                name="CancelledCheckFile"
                                                onChange={(e) => handleFileSave(e, 'cancelled_cheque_attachment')}
                                                disabled={!isEdit}
                                            />
                                            <label className="custom-file-label" htmlFor="customFile">
                                                {chequeAttach === "" ? "Choose files" : chequeAttach}
                                            </label>
                                            {errors.CancelledCheckFile && <span className="invalid">This field is required</span>}
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            <Col sm="6">
                                <div className="form-group">
                                    <label className="form-label">Contract Document</label>

                                    <div className="form-control-wrap">
                                        <div className="custom-file">
                                            <input
                                                ref={register({required: false })}
                                                type="file"
                                                className="custom-file-input"
                                                id="contractDocFile"
                                                name="ContractFile"
                                                onChange={(e) => handleFileSave(e, 'contract_document')}
                                                disabled={!isEdit}
                                            />
                                            <label className="custom-file-label" htmlFor="contractDocFile">
                                                {contractAttach === "" ? "Choose files" : contractAttach}
                                            </label>
                                            {/* {errors.ContractFile && <span className="invalid">This field is required</span>} */}
                                        </div>
                                    </div>
                                </div>
                            </Col>

                        </Row>


                        <h5 className="mt-3">Terms and Conditions</h5>



                        <Row className="g-gs">

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="signatureName">
                                        Name*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="signatureName"
                                            name="signatureName"
                                            className="form-control"
                                            defaultValue={details?.signatureName}
                                            disabled={!isEdit}
                                        />
                                        {errors.signatureName && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="signaturePlace">
                                        Place of signature*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="signaturePlace"
                                            name="signaturePlace"
                                            className="form-control"
                                            defaultValue={details?.signaturePlace}
                                            disabled={!isEdit}
                                        />
                                        {errors.signaturePlace && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>


                            <Col md="6">
                                <FormGroup style={{ zIndex: '99' }}>
                                    <label className="form-label">Date of signature*</label>

                                    <Controller
                                        control={control}
                                        name="signatureDate"
                                        render={(props) => (
                                            <DatePicker
                                                className="input"
                                                placeholderText="Select date"
                                                onChange={(e) => {
                                                    props.onChange(e);
                                                    setSignatureDate(moment(e).format('YYYY-MM-DD'))
                                                }}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                selected={props.value}
                                                dateFormat="yyyy-MM-dd"
                                                maxDate={new Date()}
                                                customInput={
                                                    <div className="form-control-wrap">
                                                        <input
                                                            ref={register({ required: true })}
                                                            type="text"
                                                            id="signatureDate"
                                                            name="signatureDate"
                                                            className="form-control"
                                                            defaultValue={signatureDate}
                                                            disabled={!isEdit}
                                                            value={signatureDate}
                                                            autoComplete="off"
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        />
                                                        {errors.signatureDate && <span className="invalid">This field is required</span>}
                                                    </div>
                                                }
                                            />
                                        )}
                                    />

                                    {errors.signatureDate && <span className="invalid">This field is required</span>}
                                </FormGroup>
                            </Col>

                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-label" htmlFor="designation">
                                        Designation*
                                    </Label>
                                    <div className="form-control-wrap">
                                        <input
                                            ref={register({ required: true })}
                                            type="text"
                                            id="designation"
                                            name="designation"
                                            className="form-control"
                                            defaultValue={details?.designation}
                                            disabled={!isEdit}
                                        />
                                        {errors.designation && <span className="invalid">This field is required</span>}
                                    </div>
                                </FormGroup>
                            </Col>



                        </Row>

                        <Row className="g-gs">
                            <Col md="12">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        ref={register({
                                            required: true,
                                        })}
                                        type="checkbox"
                                        className="form-control custom-control-input"
                                        checked
                                        id={"TOC"}
                                        name="TOC"
                                        disabled={!isEdit}
                                        readOnly
                                    // value="email"
                                    />
                                    <Label className="custom-control-label" htmlFor={"TOC"}>
                                        I have read and agreed to the terms and conditions.
                                    </Label>
                                    {errors.TOC && (
                                        <span id="fv-com-error" className="invalid">
                                            This field is required
                                        </span>
                                    )}
                                </div>

                                <br />
                                <span class="tb-lead">
                                    {/* <a href='#' onClick={toggleLg}>Terms and Conditions</a> */}
                                    <span className="text-primary" onClick={toggleLg} style={{ cursor: 'pointer', fontWeight: 'bold' }}>Terms and Conditions</span>
                                </span>

                            </Col>

                        </Row>

                        <Row className="g-gs">
                            <Col md="12">
                                <FormGroup>
                                    <button className="btn btn-primary btn-md" type="submit" disabled={!isEdit}>Save Information</button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>

                    <Modal size="lg" isOpen={modalLg} toggle={toggleLg}>
                        <ModalHeader
                            toggle={toggleLg}
                            close={
                                <button className="close" onClick={toggleLg}>
                                    <Icon name="cross" />
                                </button>
                            }
                        >
                            TERMS AND CONDITIONS FOR DESIGNER PANEL
                        </ModalHeader>
                        <ModalBody>




                            <p>By accepting these Terms and Conditions, the Designer hereby expresses its interest and submits request to Aza Fashions Private Limited (“Aza”) to be empaneled on the Aza’s Designer Panel for sale of its merchandise on www.azafashions.com (“the Website”), subject to completion of necessary empanelment formalities.
                            </p>

                            <h5>1.  EMPANELMENT </h5>
                            <p>i. During empanelment process, the Designer is required to provide details such as name of the business, full name and designation of the person accepting the terms, phone number, email address, account details, business registration details and identity and address proofs issued by the Government. Aza may contact the Designer to provide additional details or documents for verification and the Designer shall provide such details or documents. The details collected will be used for verification and communication. The details collected will be kept confidential.
                                <br />
                                ii. If there is any change in the details provided by the Designer as per Clause 1(i) at the time of empanelment or in case of any change in composition of legal entity status of the Designer’s business including but not limited to, by reason of a merger, dissolution, consolidation, conversion, or reorganization; in such case, the empaneled Designer is required to inform Aza about such change immediately and follow the instructions of Aza for implementing necessary changes in the Designer Panel. Aza will not be liable for any loss occurred to the Designer due to non-intimation of such change.
                                <br />
                                iii. All details given by the Designer should be true and correct to the best of their knowledge. Any liability arising to Aza due to incorrect, incomplete or false information furnished by the Designer shall be borne by Designer including the legal costs.
                                <br />
                                iv. Aza reserves the rights to accept, consider or reject any application for empanelment without assigning any reasons thereto.
                                <br />
                                v. The empanelment process shall be deemed to be successfully completed upon execution of an Agreement between the Designer and Aza for finalization of markdown on Maximum Retail Price of the merchandise and/or such other specific commercial terms as be mutually decided by and between the Designer and Aza.
                                <br />
                                vi. In case of any conflict or inconsistency between the terms mentioned in the Agreement and these terms and conditions, the terms mentioned in the Agreement shall prevail.
                                <br />
                                vii. Aza reserves the right to amend these Terms and Conditions at its sole discretion at any point of time.
                                <br />
                                viii. Aza does not guarantee any minimum order/payment to the empaneled Designer.
                            </p>

                            <h5>2. GENERAL TERMS FOR DISPLAY AND SALE OF DESIGNER’S MERCHANDISE ON THE WEBSITE</h5>
                            <p>i. The Designer will provide Aza proper electronic images of its merchandise to enable Aza  display the said images on its Website. Alternatively, the Designer will make available to Aza its products available for shooting images, which are suitable for listing on Aza’s Website as per the image standards.
                                <br />
                                ii. Aza may shoot the merchandise for listing on its Website as mentioned in Clause 2 (i) hereinabove. The product imagery so shot shall perpetually be the exclusive property of Aza and Aza reserves the right to use such images for its Business/Branding purposes as it may deem fit. The Designer shall not be entitled to use these images without explicit written approval of Aza. The said images may, however, be used on Designer’s own Social Media handles with due credit provided to Aza. It is expressly understood by the Designer that the said images shall not be used for promotion on any competition store or website.
                                <br />
                                iii. The merchandise collection of the Designer shall be accompanied with all the details in the proper Line-sheet format. Aza shall list the said products on its Website according to the details provided in the Line-sheet by the Designer. Any changes to the above details will have to be communicated by the Designer to the concerned Merchandiser through an email. This change shall be reflected on Aza’s Website within 1 (one) working day of receipt of the email. The Designer shall honor the Purchase Orders received before the said intimation date.
                                <br />
                                iv. Whenever a customer places an online order on Aza’s Website for a particular merchandise of the Designer, Aza will issue a Purchase Order in favor of the Designer along with the exact specifications of the merchandise prescribing the standards of quality, quantity, packaging, delivery, and other terms for the product, which shall be acknowledged by the Designer.
                                <br />
                                v. The Designer shall accordingly manufacture the merchandise exactly as per the specifications provided by Aza and shall deliver the said merchandise to Aza at its own cost including transportation cost, octroi, duties applicable etc. within such timeframe as mentioned in the line-sheet. The Designer shall take the necessary care to display the colors of the products as accurately as shown on the Website.
                                <br />
                                vi. All the merchandise should be accompanied by proper invoices and challans and other documents that may be necessary for statutory requirements.
                                <br />
                                vii. No cancellation of Purchase Order shall be allowed once the same is accepted by the Designer. If the Designer for whatever reasons is unable to make the said merchandise exactly as per the specifications or intends to cancel the Purchase Order, the same shall be informed to Aza within 2 (two) days of receipt of the Purchase Order from Aza. Any intimation for cancellations beyond this agreed period shall attract a penalty at the rate of 10% of the Order Value received by Aza. The penalty will be levied by issuing a Debit Note in the name of the Designer.
                                <br />
                                viii. In the event there is a delay in delivering the merchandise to Aza beyond 5 (five) days, Aza shall be entitled to cancel the said Order with no damages payable to the Designer for such cancellation. The Merchandise will be considered as delayed if the same is not accompanied by necessary supporting documents as mandated under various laws and necessary for accounting and processing by Aza.
                                <br />
                                ix. In case the end-customer agrees to accept the delayed delivery of the merchandise, which is delayed due to the Designer’s fault as mentioned in Clause 2(viii) and Aza at its sole discretion did not cancel the Order, the Designer shall be liable for a penalty at the rate of 10% of the Order Value received by Aza. This penalty will be levied by issuing a Debit Note in the name of the Designer.
                                <br />
                                x. Designer shall deliver the products at the designated warehouse of Aza or to any other locations as may be mutually agreed between both the Parties from time to time and Aza shall raise Goods Receipt Note (“GRN”) on the same within 3 (three) working days of such receipt.
                                xi. If the merchandise so manufactured and delivered by the Designer to Aza is not as per the exact specifications provided by Aza, then in that event, Aza shall be entitled to return the said merchandise to the Designer with no damages payable to the Designer. The cost of shipment in such an event shall be to the account of the Designer alone.
                                xii. Markdown and/or other specific commercial terms shall be decided with mutual consent between the Designer and Aza by entering into an agreement and such agreement will be part and parcel of these terms and conditions. The Designer would invoice Aza as per the agreement terms. If the Tax Invoice is not as per the agreed terms, then Aza is not liable to make any payment even if the Tax Invoice is not disputed by Aza.
                                xiii. Aza shall remit the net sale proceeds of the merchandise to the Designer on fortnightly basis for all the Designer’s merchandise sold on the Website during the fortnight period. Aza is entitled to withhold the payment of the Designer in case of any liability arises to Aza due to any default made by the Designer under the applicable laws. Aza is entitled to withhold the GST amount from the net sale proceeds without any interest if the Designer fails to comply with the requisite GST return submission and payment.

                            </p>

                            <h5>3.  VALIDITY AND TERMINATION OF EMPANELMENT</h5>
                            <p>The empanelment shall be valid until its cancellation as per following terms:
                                i. The Designer can cancel the empanelment by giving a 30 (thirty) days prior written notice sent via registered post or email to Aza. Aza at its discretion may accept requests of cancellation made on shorter notice.
                                <br />
                                ii. Notwithstanding anything contained in these Terms and Conditions, Aza reserves the right to cancel the empanelment of the Designer at any point of time without assigning any reasons thereto.

                            </p>
                            <h5>4.  INDEMNITY</h5>
                            <p>Designer agrees to indemnify, defend, and hold harmless Aza, without any limitation, from and against any loss, cost, or damage of any kind to the extent arising to Aza out of (a) Designer’s breach of any of the general or specific Terms and Conditions of its empanelment and/or of sale of its merchandise; (b) Designer’s infringement, misappropriation or violation of any intellectual property or other rights of another person or entity; or (c) any incorrect, incomplete or false details provided by the Designer.
                            </p>

                            <h5>5.  WAIVER </h5>
                            <p>No failure of either party to exercise or enforce any of its rights under these Terms and Conditions will act as a waiver of those rights.</p>

                            <h5>6.  SEVERABILITY </h5>

                            <p>Any provisions of these Terms and Conditions, which are void, illegal or otherwise unenforceable, will be severed to the extent permitted by law without affecting any other provision of these Terms and Conditions, and, if reasonably practical, will be replaced by another provision of economic equivalence, which is not so void, illegal, or unenforceable.
                            </p>

                            <h5>7.  FORCE MAJEURE</h5>

                            <p>Either Party reserves the right to cease or defer the performance of these Terms and Conditions, if it is prevented from or delayed in carrying on its business by acts, events, omissions or accidents beyond its reasonable control, including but not limited to, strikes, lock-outs or other industrial disputes (whether involving the workforce of Aza  or any other party), failure of a utility service or transport network, act of God, war, riot, civil commotion, malicious damage, compliance with any law or Governmental order, rule, regulation or direction, accident, breakdown of plant or machinery, fire, flood, storm, epidemic, pandemic (“Force Majeure Events”). Either Party shall give notice in writing whether by fax/ email/ post/ courier informing about such Force Majeure Events within 30 (thirty) days from the occurrence of such event/s. Either Party will have the right to terminate this empanelment if a force majeure occurrence continues to impact performance of the Party for more than 30 (thirty) consecutive days. Each Party agrees to take all reasonable steps to minimize the impact of a Force Majeure Event.
                            </p>

                            <h5>8.   GOVERNING LAWS AND DISPUTE RESOLUTION</h5>
                            <p>i. These Terms and Conditions are governed by the laws of the India and the courts in Mumbai shall have the exclusive jurisdiction.
                                <br />
                                ii. In the event of any dispute or difference between the Parties hereto arising out of or in connection with these terms and conditions, the same shall be referred to arbitration of a common arbitrator, if agreed upon, failing which, to 2 (two) arbitrators, 1 (one) to be appointed by each party to the arbitration. The said Arbitrators shall appoint a Presiding Arbitrator and the Arbitration shall be governed by the provisions of the Arbitration and Conciliation Act, 1996, or any statutory modification or re-enactment thereof.
                                <br />
                                iii. The arbitration proceedings shall be conducted in English language and the venue of arbitration shall be at Mumbai.
                                <br />
                                iv. Each Party shall bear its own costs of arbitration.
                            </p>


                        </ModalBody>
                    </Modal>
                </PreviewCard>
            </Block>
            <ToastContainer />
        </Content>
    </>)
};

export default DesignerDetails;